import { render } from "./SingleProductDetails.vue?vue&type=template&id=6f37424d&scoped=true&ts=true"
import script from "./SingleProductDetails.vue?vue&type=script&lang=ts"
export * from "./SingleProductDetails.vue?vue&type=script&lang=ts"

import "./SingleProductDetails.vue?vue&type=style&index=0&id=6f37424d&lang=scss&scoped=true"
import "./SingleProductDetails.vue?vue&type=style&index=1&id=6f37424d&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f37424d"]])

export default __exports__